import React from "react";

export default function CarrotDown(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="11.639" height="7.187">
			<path
				d="M10.271 0 5.819 4.442 1.368 0 0 1.368l3.736 3.736L5.82 7.188l5.819-5.819Z"
				fill={props.color || `1#142541`}
			/>
		</svg>
	);
}
